/**
 * Shows a "cross-sell offer" popup (title/description/accept/reject) after
 * this product's own add-to-cart form succeeds, for every matching `upsell`
 * metaobject entry embedded by snippets/upsell.liquid. Only reacts to
 * `cartUpdate` events sourced from `product-form` (the main buy button /
 * sticky cart), not quick-add elsewhere on the page - see that snippet's
 * comment for why this can't reliably cover quick-add-from-collection-grid.
 *
 * Each offer (keyed per metaobject entry id, in localStorage) is shown at
 * most once per browser - it's marked as shown the moment it's displayed,
 * regardless of whether the customer accepts, rejects, or dismisses it
 * (Escape / click-outside). A different offer (different metaobject entry)
 * is tracked independently.
 *
 * The modal is moved to a direct child of <body> once, to guarantee it
 * always sits above other page overlays (e.g. the cart drawer) regardless
 * of whatever stacking context it would otherwise inherit from being
 * rendered inside the product page's own layout.
 */
(function () {
  var script = document.querySelector('script[id^="UpsellOffers-"]');
  if (!script) return;

  var offers;
  try {
    offers = JSON.parse(script.textContent);
  } catch (e) {
    return;
  }
  if (!offers || !offers.length) return;

  var STORAGE_PREFIX = 'upsell-shown-';

  function hasBeenShown(id) {
    try {
      return window.localStorage.getItem(STORAGE_PREFIX + id) === '1';
    } catch (e) {
      return false;
    }
  }

  function markShown(id) {
    try {
      window.localStorage.setItem(STORAGE_PREFIX + id, '1');
    } catch (e) {
      /* ignore - worst case the offer can show again */
    }
  }

  var modal = document.getElementById('UpsellModal');
  if (!modal) return;

  document.body.appendChild(modal);

  var bannerEl = modal.querySelector('.upsell-modal__banner');
  var bannerImgEl = bannerEl.querySelector('img');
  var titleEl = modal.querySelector('.upsell-modal__title');
  var descriptionEl = modal.querySelector('.upsell-modal__description');
  var acceptEl = modal.querySelector('.upsell-modal__accept');
  var rejectEl = modal.querySelector('.upsell-modal__reject');

  var queue = [];
  var currentOffer = null;

  function showNext() {
    var offer = queue.shift();
    if (!offer) {
      currentOffer = null;
      return;
    }

    currentOffer = offer;
    markShown(offer.id);
    titleEl.textContent = offer.title || '';
    descriptionEl.textContent = offer.description || '';
    acceptEl.setAttribute('href', offer.url || '#');
    acceptEl.textContent = offer.acceptLabel || 'Explore collection';
    rejectEl.textContent = offer.rejectLabel || 'No, thank you';

    if (offer.imageUrl) {
      bannerImgEl.src = offer.imageUrl;
      bannerImgEl.srcset = offer.imageUrl + ' 1x, ' + (offer.imageUrl2x || offer.imageUrl) + ' 2x';
      bannerImgEl.alt = offer.imageAlt || '';
      bannerEl.hidden = false;
    } else {
      bannerEl.hidden = true;
      bannerImgEl.removeAttribute('src');
      bannerImgEl.removeAttribute('srcset');
    }

    modal.show();
  }

  new MutationObserver(function () {
    if (!modal.hasAttribute('open') && queue.length) {
      showNext();
    }
  }).observe(modal, { attributes: true, attributeFilter: ['open'] });

  subscribe(PUB_SUB_EVENTS.cartUpdate, function (data) {
    if (!data || data.source !== 'product-form') return;
    if (modal.hasAttribute('open')) return;

    queue = offers.filter(function (offer) {
      return !hasBeenShown(offer.id);
    });
    showNext();
  });
})();
